import { Grid } from "@material-ui/core";
import React, { useEffect } from "react";
import CustomDropdown from "utils/CustomDropdown/CustomDropdown";
import Alert from '@mui/material/Alert';
import ReactLoading from 'react-loading';
import Button from "utils/CustomButtons/Button";
import TooltipButton from "utils/TooltipButton/TooltipButton";
import { CallAPI } from "services/API";

const useMediaQuery = (query) => {
    const mediaMatch = window.matchMedia(query);
    const [matches, setMatches] = React.useState(mediaMatch.matches);

    useEffect(() => {
        const handler = e => setMatches(e.matches);
        mediaMatch.addEventListener("change", handler);
        return () => mediaMatch.removeEventListener("change", handler);
    });

    return matches;
};

//Show download button in staging environment
const production = 0;

export const Savings = (props) => {
    const isMobile = useMediaQuery('(max-width: 1152px)');
    const currency = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
    });
    const percent = new Intl.NumberFormat('en-US', {
        style: 'percent',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
    });

    const [data, setData] = React.useState([]);
    const [loading, setLoading] = React.useState(false);
    const [exportData, setExportData] = React.useState(null);
    const [exportAlert, setExportAlert] = React.useState(null);
    const [downloading, setDownloading] = React.useState(false);
    const [percentile, setPercentile] = React.useState('ANY');
    const [filteredData, setFilteredData] = React.useState(null);

    const GetData = async () => {
        let response = await CallAPI("POST", `/Home/GetSavings`, {
            startDate: props.startDate,
            endDate: props.endDate,
            states: props.states,
            city: props.city,
            percentile: percentile
        });
        
        setData(response ?? []);
        setLoading(false);
    };

    const GetExportData = async () => {
        let response = await CallAPI("POST", `/Home/ExportSavings`, {
            startDate: props.startDate,
            endDate: props.endDate,
            states: props.states,
            city: props.city,
            percentile: percentile
        });

        setExportData(response ?? []);
    };

    const DownloadCSV = async () => {
        try
        {
            let filename = "exportSavingsData_" + props.startDate + "_to_" + props.endDate + ".csv";
            let csvContent = "Quote Number,Policy Number,Previous Premium,Current Premium,Percentage Ceiling\n";

            function convertToCSVRow(obj) {
                const values = Object.values(obj);
                return values.map(value => `"${value}"`).join(",");
            }

            exportData.forEach(result => {
                const csvRow = convertToCSVRow(result);
                csvContent += csvRow + "\n";
            });

            const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
            const link = document.createElement("a");

            if (link.download !== undefined) {
                const url = URL.createObjectURL(blob);
                link.setAttribute("href", url);
                link.setAttribute("download", filename);
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            } else {
                const newTab = window.open();
                newTab.document.write(csvContent);
                newTab.document.close();
            }
        }
        catch (error)
        {
            console.error("Savings/DownloadCSV()", error);
            alert("An error occurred downloading your CSV");
        }

        setDownloading(false);
    };

    useEffect(() => {
        if (props.call === "true" || props.call === null) {
            setDownloading(false);
            setExportAlert(null);
            setExportData(null);
            setFilteredData(null);
            setLoading(true);
            setData([]);
            GetData();
        }
    }, [props.call]);

    useEffect(() => {
        setFilteredData(data?.find(x => x.percentile == percentile));
    }, [percentile, data]);

    useEffect(() => {
        if (downloading == true) {
            if (!exportData) {
                GetExportData();
            } else if (exportData.error) {
                setExportAlert(exportData.error);
                setDownloading(false);
            } else {
                DownloadCSV();
            }
        }
    }, [downloading, exportData]);

    return (
        <div
            style={{
                marginTop: "2em",
                backgroundColor: "#f1f1f1"
            }}
        >
            <Grid container

                spacing={0}

            >
                <Grid item
                    lg={3}
                    sm={5}
                    xs={9}
                    style={{ textAlign: "left" }}
                >
                    <span
                        style={
                            isMobile ?
                                {
                                    fontSize: "1.6em",
                                    color: "#1d4c80",
                                    paddingTop: "1.2em",
                                    paddingBottom: "1em",
                                    paddingLeft: ".4em",
                                    display: "inline-block"
                                }
                                :
                                {
                                    fontSize: "2em",
                                    color: "#1d4c80",
                                    paddingTop: "1.2em",
                                    paddingBottom: "1em",
                                    paddingLeft: "1em",
                                    display: "inline-block"
                                }
                        }
                    >
                        TODAY'S <b>SAVINGS</b>
                        <TooltipButton tooltipText="Now includes online and CRC data." />
                    </span>
                </Grid>
                <Grid item lg={3} sm={7} xs={3}
                    style={{
                        paddingTop: "1.2em",
                        paddingBottom: "1em",
                        textAlign: "left",
                        display: "inline-block"
                    }}
                >
                    <div style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap' }}>
                        <CustomDropdown
                            className="112122"
                            Background={"#ff8000"}
                            fontSize={"0.9em"}
                            buttonText={percentile}
                            setButtonText={(text) => setPercentile(text)}
                            Size={isMobile ? "1.1em" : "1.4em"}
                            Padding={isMobile ? ".7em" : ""}
                            dropdownList={[
                                "10%",
                                "20%",
                                "30%",
                                "40%",
                                "50%",
                                "60%",
                                "70%",
                                "80%",
                                "90%",
                                "100%",
                                "ANY"
                            ]}
                        />
                        <ReactLoading type={'spin'} style={loading == true || downloading == true ? { fill: "black", height: "30px", width: "30px", marginLeft: "1em" } : { display: "none" }} height={isMobile ? 30 : 30} width={isMobile ? 30 : 30} />
                        <Button onClick={() => { setDownloading(true); }} disabled={downloading} style={loading == false && production == 0 ? { color: 'white', marginLeft: "1em", backgroundColor: '#ff8000' } : { display: "none" }}  color="primary" size="sm"><i class="fa fa-download"></i></Button>
                        {exportAlert && (
                            <Alert severity="warning" onClose={() => setExportAlert(null)} dismissible>
                                {exportAlert}
                            </Alert>
                        )}
                    </div>
                </Grid>
                <Grid item lg xs={12} sm={6}
                    style={
                        isMobile ?
                            {
                                textAlign: "left",
                                paddingBottom: "2em",
                                fontSize: "1em"
                            }
                            :
                            {
                                paddingTop: "2em",
                                textAlign: "center",
                                paddingBottom: "2em"
                            }
                    }
                >
                    <span
                        style={{
                            fontSize: "2em"
                        }}
                    >
                        QUOTES
                    </span>
                    <span
                        style={{
                            color: "#ff8000",
                            paddingLeft: ".5em",
                            fontSize: "2em",
                        }}>
                        {filteredData?.quotes ?? '--/--'}
                        <TooltipButton tooltipText="Includes only applicants that provided previous premium values between $200-$5,000 for a 6-month term.  #Quotes with Savings/Total Quotes meeting prev carrier premium criteria" />
                    </span>
                </Grid>
                <Grid item lg xs={12} sm={6}
                    style={
                        isMobile ?
                            {
                                textAlign: "left",
                                paddingBottom: "2em",
                                fontSize: "1em"
                            }
                            :
                            {
                                paddingTop: "2em",
                                textAlign: "center",
                                paddingBottom: "2em"
                            }
                    }
                >
                    <span
                        style={{
                            fontSize: "2em"
                        }}
                    >
                        BOUND
                    </span>
                    <span
                        style={{
                            color: "#ff8000",
                            fontSize: "2em",
                            paddingLeft: ".5em",
                        }}>
                        {filteredData?.bound ?? '--/--'}
                        <TooltipButton tooltipText="Includes only applicants that provided previous premium values between $200-$5,000 for a 6-month term.  #Binds with Savings/Total Binds meeting prev carrier premium criteria" />
                    </span>
                </Grid>
            </Grid>
            <Grid container>
                <SavingsTile
                    key={1}
                    Text="Avg. Savings Per Quote"
                    Val={filteredData && currency.format(filteredData.avgSavingsPerQuote) || '$--'}
                    Popover="Includes only quotes in which money was saved"
                />
                <SavingsTile
                    key={2}
                    Text="Highest Savings Any Single Quote"
                    Val={filteredData && currency.format(filteredData.highestSavingsAnySingleQuote) || '$--'}
                />
                <SavingsTile
                    key={3}
                    Text="Quotes Applicant Saved Money"
                    Val={filteredData && percent.format(filteredData.quotesApplicantSavedMoneyPercentage / 100) || '--%'}
                />
            </Grid>
            <Grid container>
                <SavingsTile
                    key={4}
                    Text="Avg Savings Per Bound Policy"
                    Val={filteredData && currency.format(filteredData.avgSavingsPerBoundPolicy) || '$--'}
                    Popover="Includes only quotes in which money was saved"
                />
                <SavingsTile
                    key={5}
                    Text="Highest Savings on Any Single Bound Policy"
                    Val={filteredData && currency.format(filteredData.highestSavingsOnAnySingleBoundPolicy) || '$--'}
                />
                <SavingsTile
                    key={6}
                    Text="Bound Policies Applicant Saved Money"
                    Val={filteredData && percent.format(filteredData.boundPoliciesApplicantSavedMoneyPercentage / 100) || '--%'}
                />
            </Grid>
        </div>
    );
}

const SavingsTile = (props) => {
    const isMobile = useMediaQuery('(max-width: 1152px)');
    return (
        <Grid container
            style={isMobile ? {
                backgroundColor: "#e4e4e4",
                height: "10em",
                marginBottom: "2em",
                fontSize: "1.1em"
            }
                :
                {
                    backgroundColor: "#e4e4e4",
                    height: "8em",
                    marginLeft: "1em",
                    marginBottom: "1em",
                    maxWidth: "31%",
                    fontSize: "1.5em"
                }
            }
        >

            <Grid item xs={7}
                style={isMobile ?
                    {
                        fontSize: "1.4em",
                        padding: "1em",
                        lineHeight: "1.3em"
                    }
                    :
                    {
                        fontSize: "1.2em",
                        padding: "1em",
                        lineHeight: "1.3em"
                    }
                }
            >
                {props.Text}
                {!!props.Popover && <TooltipButton tooltipText={ props.Popover} />}
            </Grid>
            <Grid item xs={5}
                style={
                    isMobile ?
                        {
                            fontSize: "1.9em",
                            color: "#ff8000",
                            paddingTop: "1.9em",
                            fontWeight: "",
                            textAlign: "center"
                        }
                        :
                        {
                            fontSize: "1.8em",
                            color: "#ff8000",
                            paddingTop: "1.5em",
                            fontWeight: "",
                            textAlign: "center"
                        }
                }
            >
                {props.Val}
            </Grid>
        </Grid>
    );
}